import { Typography } from "@mui/material"
import type { FC } from "react"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface ShipToLocationCellProps {
  location?: Partial<Location> | null
}

export const ShipToLocationCell: FC<ShipToLocationCellProps> = ({ location }) => {
  if (!location) return <Typography variant='body2'>-</Typography>

  const formatted = formatLocationAddress(location as Location, AddressFormat.Medium)
  if (!formatted) return <Typography variant='body2'>-</Typography>

  return (
    <Typography variant='body2' className='font-medium'>
      {formatted}
    </Typography>
  )
}
